import { useEffect } from "react";
import sal from "sal.js";
import { useLocation } from "react-router-dom";

const ScrollAndSal = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    sal({ threshold: 0.2, once: true });

    const observer = new MutationObserver(() => {
      sal({ threshold: 0.2, once: true });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [location]);

  return children;
};

export default ScrollAndSal;